//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const URL_REGEX =
  '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)';
export const URL_REGEX_WITH_PROTOCOL =
  'http(s)?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)';
export const URL_REGEX_PROTOCOL_ONLY = '^http(s)?:\\/\\/.*';

export default function isValidUrl(url: string) {
  const urlRegex = new RegExp(URL_REGEX, 'i');
  return urlRegex.test(url);
}

export function isValidUrlWithProtocol(url: string) {
  const urlRegex = new RegExp(URL_REGEX_WITH_PROTOCOL, 'i');
  return urlRegex.test(url);
}

export function hasValidProtocol(url: string) {
  const urlRegex = new RegExp(URL_REGEX_PROTOCOL_ONLY, 'i');
  return urlRegex.test(url);
}

/**
 * Tests that a url matches the (https://)cur.lt/... pattern
 *
 * Note: expected that url is validated before using
 *
 * @param url
 */
export function isCuralateShortLink(url: string) {
  const curalateShortLinkRegex = new RegExp('^(?:https://)?(?:cur.lt/.)', 'i');
  return curalateShortLinkRegex.test(url);
}
